var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-6"},[_c('div',{staticClass:"button is-primary is-fullwidth py-5"},[_c('a',{staticClass:"has-text-weight-semibold",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }